export default __webpack_public_path__ + "static/media/exam-upload-icon.8703335d.svg";